const GA_ID = window?.chatwootConfig?.viteAppGaId;
const FB_PIXEL_ID = window?.chatwootConfig?.viteAppFbPixelId;

export const initAnalytics = () => {
  console.info("-----------initAnalytics--------------")
  // 初始化 Google Analytics (GA)
  const googleScript = document.createElement('script');
  googleScript.async = true;
  googleScript.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(googleScript);

  const googleInlineScript = document.createElement('script');
  googleInlineScript.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${GA_ID}');
  `;
  document.head.appendChild(googleInlineScript);

  // 初始化 Meta Pixel (Facebook Pixel)
  const fbScript = document.createElement('script');
  fbScript.innerHTML = `
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '${FB_PIXEL_ID}');
    fbq('track', 'PageView');
  `;
  document.head.appendChild(fbScript);

  // Noscript 方式添加 Meta Pixel 代码
  const fbNoscript = document.createElement('noscript');
  fbNoscript.innerHTML = `
    <img height="1" width="1" style="display:none"
         src="https://www.facebook.com/tr?id=${FB_PIXEL_ID}&ev=PageView&noscript=1"/>
  `;
  document.body.appendChild(fbNoscript);
};

export const trackPageView = (path) => {
  if (window.gtag && GA_ID) {
    console.info("===================trackPageView1==============")
    window.gtag('config', GA_ID, { page_path: path });
  }
  if (window.fbq && FB_PIXEL_ID) {
    console.info("===================trackPageView2==============")
    window.fbq('track', 'PageView');
  }
};
